import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { GA4_MEASUREMENT_ID, trackScroll75 } from '@/lib/ga4';

/**
 * Global GA4 component:
 * - Sends page_view on every route change
 * - Tracks scroll >= 75% once per page
 * - Initialises GA4 config (in addition to Google Ads already in index.html)
 */
export function GA4GlobalTracker() {
  const { pathname } = useLocation();
  const scrollTracked = useRef(false);

  // ── Send GA4 page_view on route change ─────────────────
  useEffect(() => {
    scrollTracked.current = false;

    if (typeof window.gtag === 'function') {
      window.gtag('config', GA4_MEASUREMENT_ID, {
        page_path: pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);

  // ── Scroll 75% tracking ────────────────────────────────
  useEffect(() => {
    const handleScroll = () => {
      if (scrollTracked.current) return;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;
      const pct = window.scrollY / scrollHeight;
      if (pct >= 0.75) {
        scrollTracked.current = true;
        trackScroll75();
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  return null;
}
